import { BrandMolecula } from "./BrandMolecula";
import { BrandWordmark } from "./BrandWordmark";

interface BrandProps {
  /** Target wordmark height in px. Default 14. */
  height?: number;
  /** Render the molecule mark. Default true. */
  withMark?: boolean;
  /** Render the "B2B" chip after the wordmark. Default true. */
  showChip?: boolean;
  /** Border colour for the chip — defaults to `--line-2` token. */
  chipBorder?: string;
  /** Text colour for the chip — defaults to `--ink-3` token. */
  chipColor?: string;
}

/**
 * Composite Foundation brand mark: molecule + wordmark + B2B chip.
 *
 * Sizing follows the React reference contract: mark height ≈ 1.4 × word height,
 * gap ≈ 0.4 × word height. Dark theme inversion is delegated to the child SVGs
 * via `var(--brand-filter)`.
 */
export function Brand({
  height = 14,
  withMark = true,
  showChip = true,
  chipBorder = "var(--line-2)",
  chipColor = "var(--ink-3)",
}: BrandProps) {
  const markSize = Math.round(height * 1.4);
  const gap = Math.max(4, Math.round(height * 0.4));

  return (
    <span
      className="brand"
      style={{ display: "inline-flex", alignItems: "center", gap }}
    >
      {withMark && <BrandMolecula size={markSize} />}
      <BrandWordmark height={height} />
      {showChip && (
        <span
          className="brand__chip mono"
          style={{
            fontSize: Math.max(8.5, Math.round(height * 0.66)),
            padding: "1px 5px",
            border: `1px solid ${chipBorder}`,
            borderRadius: 3,
            color: chipColor,
            letterSpacing: "0.08em",
            fontWeight: 500,
            lineHeight: 1.3,
            flexShrink: 0,
          }}
        >
          B2B
        </span>
      )}
    </span>
  );
}
